import {Button, Divider, Drawer, NavLink} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {useMemo} from "react";
import {useNavigate, useParams} from "react-router";
import withRouteErrorBoundary from "../../components/ErrorBoundary/withRouteErrorBoundary";
import {Row, Col} from "../../components/Flex/Flex";
import Page from "../../components/Page/Page";
import useScreenSize from "../../components/useScreenSize";
import AFProspecting from "./AFProspecting";
import AFShields from "./AFShields";
import BountyHunting from "./BountyHunting";
import CreatureSpawn from "./CreatureSpawn";
import DoorCompare from "./DoorCompare";
import DoorDemolition from "./DoorDemolition";
import EntityHistoryCompare from "./EntityHistoryCompare";
import EntityStatCompare from "./EntityStatCompare";
import Force from "./Force";
import Locks from "./Locks";
import Medical from "./Medical";
import Mining from "./Mining";
import PersonalWeapons from "./PersonalWeapons";
import ShipCapture from "./ShipCapture";
import ShipSpeed from "./ShipSpeed";
import ShipWeapons from "./ShipWeapons";


function Charts () {
    const {tab} = useParams();
    const navigate = useNavigate();
    const {isMedium} = useScreenSize();
    const [opened, { open, close }] = useDisclosure(false);


    const items = useMemo(() => {
        return [
            {label: 'Medical', id: 'medical',},
            {label: 'Force', id: 'force'},
            {label: 'Bounty Hunting', id: 'bounty-hunting',},
            {label: 'Creature Spawn', id: 'creature-spawn'},
            {separator: true},
            {label: 'Doors: Locks', id: 'locks'},
            {label: 'Doors: Demolition', id: 'demolition'},
            {label: 'Doors: Compare', id:'compare'},
            {label: 'Ship Capture', id: 'ship-capture'},
            {separator: true},
            {label: 'AF Mining', id: 'af-mining'},
            {label: 'AF Shields', id:'af-shields'},
            {label: 'Mining', id: 'mining'},
            {separator: true},
            {label: 'Combat: Ship Weapons', id: 'ship-weapons'},
            {label: 'Combat: Personal Weapons', id: 'personal-weapons'},
            {label: 'Compare: Ships', id:'ship-compare'},
            {label: 'Ship Speed', id: 'ship-speed'},
            {separator: true},
            {label: 'Changes: Ships', id: 'changes-ships'},
            {label: 'Changes: Stations', id: 'changes-stations'},
        ]
    }, []);

    const navMenu = <div>
        {items.map((item, index) =>
            item.separator ? <Divider key={index} /> : <NavLink key={index} label={item.label} onClick={() => {
                navigate('/charts/'+item.id)
                close();
            }} active={item.id === tab} />
        )}
    </div>;

    return (
        <Page>
            <Row wrap={!isMedium}>
                <Col shrink={0}>
                    {isMedium ? navMenu: (
                        <>
                            <Button onClick={open}>Charts</Button>
                       <Drawer title="Charts" opened={opened} onClose={close}>
                           {navMenu}
                       </Drawer>
                       </>
                    )}
                </Col>
                <Col grow={1} shrink={1}>
                    {tab === 'locks' ? <Locks /> : null}
                    {tab === 'medical' ? <Medical /> : null}
                    {tab === 'force' ? <Force /> : null}
                    {tab === 'demolition' ? <DoorDemolition /> : null}
                    {tab === 'compare' ? <DoorCompare /> : null}
                    {tab === 'af-mining' ? <AFProspecting /> : null}
                    {tab === 'af-shields' ? <AFShields /> : null}
                    {tab === 'bounty-hunting' ? <BountyHunting /> : null}
                    {tab === 'ship-weapons' ? <ShipWeapons /> : null}
                    {tab === 'personal-weapons' ? <PersonalWeapons /> : null}
                    {tab === 'ship-compare' ? <EntityStatCompare /> : null}
                    {tab === 'ship-speed' ? <ShipSpeed /> : null}
                    {tab === 'ship-capture' ? <ShipCapture /> : null}
                    {tab === 'changes-ships' ? <EntityHistoryCompare type="ships" /> : null}
                    {tab === 'changes-stations' ? <EntityHistoryCompare type="stations" /> : null}
                    {tab === 'creature-spawn' ? <CreatureSpawn /> : null}
                    {tab === 'mining' ? <Mining /> : null}
                </Col>
            </Row>
        </Page>
    )
}

export default withRouteErrorBoundary(Charts);
